import { apiPost } from './client';
import { ApiResponse } from '@tinyrewards/shared';

export function generateBadgeDetails(data: {
    badgeType: string;
    badgeName?: string;
    badgeDescription?: string;
    textContent?: string;
}): Promise<ApiResponse<{ name?: string; description?: string; tags?: string }>> {
    return apiPost<{ name?: string; description?: string; tags?: string }>('/api/ai/generate-details', data);
}

export function generateCriteria(data: {
    badgeName: string;
    badgeDescription: string;
}): Promise<ApiResponse<{ criteria: string }>> {
    return apiPost<{ criteria: string }>('/api/ai/generate-criteria', data);
}

export function generateBadgeImage(badgeJson: string): Promise<ApiResponse<{ imageUrl: string }>> {
    return apiPost<{ imageUrl: string }>('/api/ai/badge-image', { badgeJson });
}

export function fetchUrlInfo(url: string): Promise<ApiResponse<{ title: string; description: string; textContent: string }>> {
    return apiPost<{ title: string; description: string; textContent: string }>('/api/ai/url-info', { url });
}

export interface QuizQuestion {
    question: string;
    options: string[];
    correctAnswer: string;
    feedback: { correct: string; incorrect: string };
}

export function generateQuestions(data: {
    url?: string;
    description?: string;
    type?: 'website' | 'text';
    count?: number;
}): Promise<ApiResponse<{ questions: QuizQuestion[] }>> {
    return apiPost<{ questions: QuizQuestion[] }>('/api/ai/questions', data);
}
